import { createContext } from 'react';
import { WrappedGoal } from 'src/careflow/ph-core/fhir-client/fhir-base/wrappers/Goal';
import { Extension } from 'src/careflow/ph-core/fhir-client/resources';

export interface RelatedGoal {
  extension: Extension[];
  wrappedGoal: WrappedGoal;
}

export interface GoalContextData {
  relatedGoals?: RelatedGoal[];
  isWorkflowContext?: boolean;
}

const initialGoalContextData: GoalContextData = {
  relatedGoals: [],
};

const GoalContext = createContext<GoalContextData>(initialGoalContextData);

export default GoalContext;
